import { DependencyList, useEffect, useState } from 'react'
import { useTimeoutFn } from 'react-use'

export const useDebouncedVariable = <T>(
  variable: T,
  delay: number,
  deps: DependencyList
): [T, boolean] => {
  // Start off as loading: true.
  const [shouldSkip, setShouldSkip] = useState<[T, boolean]>([variable, true])

  const [, , reset] = useTimeoutFn(() => {
    setShouldSkip([variable, false])
  }, delay)

  useEffect(() => {
    reset()
    // Set as loading, without changing the variable reference.
    setShouldSkip(([variable]) => [variable, true])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reset, ...deps])

  return shouldSkip
}
